'use client'

import { useState, useEffect } from 'react'

interface CallTimerProps {
  initialSeconds?: number
  className?: string
}

export function CallTimer({ initialSeconds = 165, className = '' }: CallTimerProps) {
  const [seconds, setSeconds] = useState(initialSeconds)

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 0) {
          return initialSeconds // Reset when reaching 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [initialSeconds])

  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60

  return (
    <span className={className}>
      {minutes}:{remainingSeconds.toString().padStart(2, '0')}
    </span>
  )
}

